import { useMutation } from '@tanstack/react-query';
import { getLesson } from '../queries/module';
import { useLessonStore } from '../stores/lessonStore';
import { useLessonContentStore } from '../stores/lessonContentStore';

export function useLesson() {
  const setLessons = useLessonStore.getState().setLessons;
  const setAllLessons = useLessonContentStore.getState().setAllLessons;
  
  const { mutate, isPending, isError } = useMutation({ 
    mutationKey: ['lesson'], 
    mutationFn: (module: string) => getLesson(module),
    retry: false,
    onSuccess: (result) => {
      setLessons(result);
      setAllLessons(result);
    }
  });

  return { mutate, isPending, isError };
}
